// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  width: 100%;
  height: 100%;
}

:root{
  --font-family: Arial, Helvetica, sans-serif;
  --sidebar-font-family: var(--font-family);
  --gap-color: #f5f7fb;
  --row-header-background: rgba(44, 202, 255, 0.17);
  --dropdown-select: rgba(44, 202, 255, 0.17);
  --expanded-row-header-background: rgb(0 0 0 / 20%);
  --expanded-row-container-background: rgb(0 0 0 / 5%);
  --white: #ffffff;
  --black: #000000;
  --primary-col: #12c1f9;
  --secondary-col: #231f20;
  --link-active: #12c1f9;
  --bg: #f5f7fb;
  --link-items: #a9aaab;
  --link-icon: #535457;
  --notification: #8fa0b9;
  --notification-active: #e80000;
  --primary-background: #ffffff;
  --section-background: 0.5px solid rgba(83, 84, 87, 0.6);
  --highlighted-color:rgba(18, 193, 249, 0.9);
  --box-shadow: 7px 4px 6px 1px rgb(0 0 0 / 28%);
  --row-color: #DEF1F8;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

* {
  padding: 0;
  margin: 0;
  outline: 0;
}
*,
*::after,
*::before {
  box-sizing: inherit;
}

body ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px!important;
  height: 5px!important;
}

body {
  color: var(--secondary);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.618;
  background-color: var(--bg);
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.icon:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,oBAAoB;EACpB,iDAAiD;EACjD,2CAA2C;EAC3C,kDAAkD;EAClD,oDAAoD;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,uDAAuD;EACvD,2CAA2C;EAC3C,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;AACd;;AAEA;EACE;aACW;AACb;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Montserrat');\n\n#root {\n  width: 100%;\n  height: 100%;\n}\n\n:root{\n  --font-family: Arial, Helvetica, sans-serif;\n  --sidebar-font-family: var(--font-family);\n  --gap-color: #f5f7fb;\n  --row-header-background: rgba(44, 202, 255, 0.17);\n  --dropdown-select: rgba(44, 202, 255, 0.17);\n  --expanded-row-header-background: rgb(0 0 0 / 20%);\n  --expanded-row-container-background: rgb(0 0 0 / 5%);\n  --white: #ffffff;\n  --black: #000000;\n  --primary-col: #12c1f9;\n  --secondary-col: #231f20;\n  --link-active: #12c1f9;\n  --bg: #f5f7fb;\n  --link-items: #a9aaab;\n  --link-icon: #535457;\n  --notification: #8fa0b9;\n  --notification-active: #e80000;\n  --primary-background: #ffffff;\n  --section-background: 0.5px solid rgba(83, 84, 87, 0.6);\n  --highlighted-color:rgba(18, 193, 249, 0.9);\n  --box-shadow: 7px 4px 6px 1px rgb(0 0 0 / 28%);\n  --row-color: #DEF1F8;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  outline: 0;\n}\n*,\n*::after,\n*::before {\n  box-sizing: inherit;\n}\n\nbody ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 5px!important;\n  height: 5px!important;\n}\n\nbody {\n  color: var(--secondary);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.618;\n  background-color: var(--bg);\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 100%;\n  height: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.icon:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
